export default __webpack_public_path__ + "static/media/avatar.5e5ad722.svg";